import { Document } from "@react-pdf/renderer";
import PdfDataItemRowCentered from "../pdfBuilder/components/data/PdfDataItemRowCentered";
import PdfPageBrandedIntro from "../pdfBuilder/ui/pages/PdfPageBrandedIntro";
import PdfPageDisclosureAndSignature from "../pdfBuilder/ui/pages/PdfPageDisclosureAndSignature";
import PdfPageBorrowerBackgroundExperience from "./pages/PdfPageBorrowerBackgroundExperience";
import PdfPageBorrowerInformation from "./pages/PdfPageBorrowerInformation";
import PdfPageBorrowingEntityInformation from "./pages/PdfPageBorrowingEntityInformation";
import PdfPageLoanDetails from "./pages/PdfPageLoanDetails";
import PdfPageSubjectProperties from "./pages/PdfPageSubjectProperties";

// Create styles for the PDF

// Individual PDF Components

/**
 * SPECIFIC TO LOAN APP
 */

// Main PDF Document Component
const LoanApplicationPDF = ({ formData }) => (
  <Document>
    {/* Page 1: Borrower Details */}
    <PdfPageBrandedIntro
      pageNumber={"1 of 6"}
      title={"Loan Application"}
      applicationFor={`${formData?.firstName} ${formData?.lastName}`}
      applicationDate={formData?.submission_date}
    >
      <PdfDataItemRowCentered
        label={"Loan Product Type:"}
        value={formData?.loanProductType}
      />

      <PdfDataItemRowCentered
        label={"Loan Purpose:"}
        value={formData?.loanPurpose}
      />
    </PdfPageBrandedIntro>

    <PdfPageBorrowerInformation formData={formData} />

    {/* Page 2: Background & Experience */}
    <PdfPageBorrowerBackgroundExperience formData={formData} />

    {/* Page 3: Loan Details */}
    <PdfPageLoanDetails formData={formData} />

    {/* Page 4: Properties */}
    <PdfPageSubjectProperties formData={formData} />

    {/* Page 5: Entity Information */}
    <PdfPageBorrowingEntityInformation formData={formData} />

    {/* Page 6: Disclosure & Signature */}
    <PdfPageDisclosureAndSignature
      pageNumber={"6 of 6"}
      formData={formData}
      type={"loanApplication"}
    />
  </Document>
);

export default LoanApplicationPDF;
